<div class="errwrap">
  <div class="errdiv1" id="errs"></div>
</div>
<div *ngIf="actionmode == 'Add' || actionmode == 'Edit'" class="searchdiv">
  <div class="card screen-wrapper">
    <div class="header headerdiv">
      <h1 class="screen-title">{{ screentitle }}</h1>
      <div class="button-wrapper bothbuttdiv2">
        <div *ngIf="actionmode == 'Add' || actionmode == 'Edit'" class="btn back-button button-margin">
          <button class="btn btn-primary commonbutt" type="button" (click)="submitData1()">
            <em>="fa fa-check"></em>&nbsp;Submit
          </button>
          <button class="btn btn-success commonbutt" type="button">
            <em>="fa fa-thumbs-up "></em>&nbsp;&nbsp;
            <span class="bold">Approve</span>
          </button>
          <button class="btn btn-warning commonbutt" type="button">
            <em>="fa fa-thumbs-down"></em> <span class="bold">Reject</span>
          </button>
          <button class="btn btn-danger commonbutt" (click)="searchForm()" type="button">
            <em>="fa fa-times"></em>&nbsp;Close
          </button>
        </div>
      </div>
    </div>

    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <div class="form-div">
            <div class="row">
              <div class="m-portlet">
                <div style="padding: 2% 2% 2% 2%"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="actionmode != 'Add' && actionmode != 'Edit' && actionmode != 'View'" class="searchdiv">
  <div class="headerdiv">
    <h1>Audit Log</h1>
    <div class="bothbuttdiv"></div>
  </div>
  <div class="card-body">
    <div class="row">
      <div class="col-md-12">
        <div class="form-div">
          <div class="row">
            <div class="m-portlet">
              <div>
                <div>
                  <div>
                    <div class="col-lg-3">
                      <label>Module</label>
                      <select class="form-control m-input" [(ngModel)]="screen_details.module"
                        (change)="getComponent()">
                        <option selected>Select Module</option>

                        <option value="Frontend">Frontend</option>
                        <option value="Backend">Backend</option>
                      </select>
                    </div>

                    <div class="col-lg-3">
                      <label>Component</label>
                      <select class="form-control m-input" [(ngModel)]="screen_details.component"
                        (change)="HideFields()">
                        <option value="{{ combo }}" *ngFor="let combo of ComponentArray">{{ combo }}</option>
                      </select>
                    </div>

                    <div *ngIf="!hide2Fields" class="col-md-3">
                      <label>From</label>
                      <input class="form-control m-input" type="time" name="usr_time"
                        [(ngModel)]="screen_details.from" />
                    </div>

                    <div *ngIf="!hide2Fields" class="col-md-3">
                      <label>To</label>
                      <input class="form-control m-input" type="time" name="usr_time" [(ngModel)]="screen_details.to" />
                    </div>
                  </div>
                  <div>
                    <div class="btn clear-button button-margin" style="margin-left: 1075px">
                      <button style="margin-top: 20px;" class="btn btn-primary commonbutt" (click)="searchData()"
                        type="button">
                        <em>="fa fa-search "></em>&nbsp;Search
                      </button>
                    </div>
                  </div>
                  <div *ngIf="hideTable" class="makeIt">
                    <table aria-describedby="auditLogDetails" class="table table-bordered">
                      <tr>
                        <th scope="col">Sr.No</th>
                        <th scope="col">Log Discription</th>
                      </tr>
                      <tr *ngFor="
                          let q of (dispalyLog
                            | paginate: { itemsPerPage: 10, currentPage: p });
                          let i = index
                        ">
                        <td>{{ i + 1 }}</td>

                        <td>
                          <button class="btn btn-primary commonbutt" data-toggle="modal" data-target="#myModal10"
                            (click)="showPopUp(q)" type="button">
                            View
                          </button>
                        </td>
                      </tr>
                    </table>

                    <tfoot>
                      <tr>
                        <td colspan="2">
                          <pagination-controls (pageChange)="p = $event"></pagination-controls>
                        </td>
                      </tr>
                    </tfoot>
                  </div>

                  <br />

                  <div *ngIf="loader">
                    <div style="margin:auto; text-align: center">
                      <img src="../../../../../assets/img/Loading_Animation.gif" width="8%" height="8%" alt="Loader" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="myModal10" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header" style="padding:20px 50px;">
        <strong>Log Info </strong>

        <button type="button" class="close" data-dismiss="modal">
          &times;
        </button>
      </div>

      <div class="modal-body">
        <ul *ngFor="let q of logArray">
          <li>{{ q }}</li>
          <li>
            <p>
              -----------------------------------------------------------------
            </p>
          </li>
        </ul>
      </div>
      <div class="modal-footer">
        <button class="btn btn-success " type="button" data-dismiss="modal">
          Close
        </button>
      </div>
    </div>
  </div>
</div>